import { render, staticRenderFns } from "./barCard.vue?vue&type=template&id=0df58a6e&scoped=true"
import script from "./barCard.vue?vue&type=script&lang=js"
export * from "./barCard.vue?vue&type=script&lang=js"
import style0 from "./barCard.vue?vue&type=style&index=0&id=0df58a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df58a6e",
  null
  
)

export default component.exports